/**
 * Backup codes look like `cFG3k-9Sp2V` (5 + 5 characters). Capitals matter, but people drop the dash when typing
 * them from a printout, so put it back before checking (Figma A01.4: "the dash is optional").
 */
export function normalizeBackupCode(raw: string): string {
  const compact = raw.replace(/\s+/g, '');
  if (!compact.includes('-') && compact.length === 10) return `${compact.slice(0, 5)}-${compact.slice(5)}`;
  return compact;
}
